import { Checkbox, Form, Input, Select, Space } from 'antd'
import React from 'react'
import PlusCircleOutlined from "@ant-design/icons/PlusCircleOutlined";
import MinusCircleOutlined from "@ant-design/icons/MinusCircleOutlined";
import './style.css'

const DeviceIdDetails = ({ formUser }) => {
    const deviceIdDetails = Form.useWatch('device_id', formUser);

    return (
        <div className='ipformitem-space'>
            
            <Form.Item noStyle >
                <Form.List name={['device_id']} initialValue={[{type:'1', id:''},{type:'2', id:''}]}>
                    {(fields, { add, remove }) => (
                        <>

                            {fields.map((field, index) => (
                                <div
                                    key={field.key}
                                    className='deviceformitem-list'
                                    // align="baseline"
                                >
                                    <Form.Item
                                        style={{ marginBottom: 10, width: '24%', marginRight: 8 }}
                                        name={[field.name, 'type']}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Required!',
                                            },
                                        ]}
                                    >
                                        <Select disabled placeholder="Select" style={{ width: '100%', cursor: 'pointer' }} >
                                            <Select.Option value={'Desktop'} key={1}>Desktop</Select.Option>
                                            <Select.Option value={'Mobile'} key={2}>Mobile</Select.Option>
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        name={[field.name, 'manufacturer']}
                                        style={{ marginBottom: 10, width: '38%', marginRight: 8 }}

                                    >
                                        <Input readOnly></Input>
                                    </Form.Item>

                                    <Form.Item
                                        name={[field.name, 'model']}
                                        style={{ marginBottom: 10, width: '38%', marginRight: 8 }}
                                    >
                                        <Input readOnly></Input>
                                    </Form.Item>
                                    
                                  


                                </div>
                            ))}
                        </>
                    )}
                </Form.List>
            </Form.Item>
        </div>
    )
}

export default DeviceIdDetails